package com.milta.feature.ocrscan.data.remote.dto

import com.milta.feature.ocrscan.domain.entity.OcrScanResult
import com.milta.feature.ocrscan.domain.entity.ScannedDelivery
import com.milta.feature.route.domain.entity.toGeocodeFailureReason
import com.milta.feature.route.domain.entity.toGeocodeStatus
import kotlinx.serialization.Serializable

/** Mirrors the backend `OcrScanResultDto` (POST /api/v1/ocr-scans, contrat révisé DOM-02). */
@Serializable
data class OcrScanResultDto(
    val totalCount: Int,
    val incompleteCount: Int,
    val deliveries: List<ScannedDeliveryDto>,
)

/** Mirrors the backend `OcrScannedDeliveryDto` — one row read off the paper list, nothing persisted. */
@Serializable
data class ScannedDeliveryDto(
    val recipientName: String? = null,
    val address: String? = null,
    val phoneNumber: String? = null,
    val deadlineTime: String? = null,
    val hasMissingFields: Boolean,
    val packageCount: Int = 1,
    val geocodeStatus: String = "Pending",
    val latitude: Double? = null,
    val longitude: Double? = null,
    val geocodeFailureReason: String? = null,
    val resolvedAddress: String? = null,
)

fun OcrScanResultDto.toDomain() = OcrScanResult(
    totalCount = totalCount,
    incompleteCount = incompleteCount,
    deliveries = deliveries.map { it.toDomain() },
)

fun ScannedDeliveryDto.toDomain() = ScannedDelivery(
    recipientName = recipientName,
    address = address,
    phoneNumber = phoneNumber,
    deadlineTime = deadlineTime,
    hasMissingFields = hasMissingFields,
    packageCount = packageCount,
    geocodeStatus = geocodeStatus.toGeocodeStatus(),
    latitude = latitude,
    longitude = longitude,
    geocodeFailureReason = geocodeFailureReason.toGeocodeFailureReason(),
    resolvedAddress = resolvedAddress,
)
